import { Component, Injectable, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeactivateWorkstationDialogComponent } from '@settings/link-up/components/link-up-workstations-list/deactivate-workstation-dialog/deactivate-workstation-dialog.component';
import { ILinkUp } from '@pdqdev/pdq-shared/dist/interfaces/ILinkUp';
import { PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { LinkUpService } from '@app/services/link-up/link-up.service';

@Injectable()
@Component({
  selector: 'link-up-workstations-list',
  templateUrl: './link-up-workstations-list.component.html',
  styleUrls: ['./link-up-workstations-list.component.scss'],
  standalone: false,
})
export class LinkUpWorkstationsListComponent implements OnInit {
  @Input() workstations: ILinkUp.Workstation[];
  @Input() currentPdqUser: PdqUser;
  constructor(
    private dialog: MatDialog,
    private linkUpService: LinkUpService,
  ) {}

  ngOnInit(): void {}

  openDeactivateDialog(workstation) {
    this.dialog.open(DeactivateWorkstationDialogComponent, {
      autoFocus: false,
      data: {
        workstation,
      },
    });
  }

  openRenameDialog(workstation) {
    this.linkUpService.openRenameWorkstationDialog(workstation);
  }
}
